import {authHeader} from '../../helpers/index';
import {baseUrl} from '../constants';
import {handleResponse} from './responseHandler';

export const unitPmService = {};

const apiUrl = baseUrl;

unitPmService.createUnitPm = (unit_pm) => {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('POST'),
        body: JSON.stringify(unit_pm)
    };

    return fetch(`${apiUrl}/unit_pm`, requestOptions).then(handleResponse);
};

unitPmService.updateUnitPm = (unit_pm) => {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader('PUT'),
        body: JSON.stringify(unit_pm)
    };

    return fetch(`${apiUrl}/unit_pm/${unit_pm.id}`, requestOptions).then(handleResponse);
};

unitPmService.getAll = () => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/unit_pms`, requestOptions).then(handleResponse)
};

unitPmService.getPm = (id) => {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('GET')
    };

    return fetch(`${apiUrl}/unit_pm/` + id, requestOptions).then(handleResponse);
};
